import api from '../../api';
import useHttpData from '../useHttpData';

// Fetches the retailer's onboarded gateways aggregated per price area: gateway counts
// plus summed battery capacity (kWh), charge/discharge power and the two nameplate power
// figures read from the inverters (kW). Scoped to the authenticated retailer server-side.
const useHttpGetGatewayPriceAreaSummary = () => {
    const { data, isReady, error } = useHttpData(() => api.get_gateway_price_area_summary(), []);

    return {
        areas: data?.data ?? [],
        notOnboardedCount: data?.not_onboarded_count ?? 0,
        isReady,
        error,
    };
};

export default useHttpGetGatewayPriceAreaSummary;
